/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProjectResponseAdminDto } from '../../models/project-response-admin-dto';

export interface AdminProjectsControllerUnpublishProjectV1$Params {
  id: string;
}

export function adminProjectsControllerUnpublishProjectV1(http: HttpClient, rootUrl: string, params: AdminProjectsControllerUnpublishProjectV1$Params, context?: HttpContext): Observable<StrictHttpResponse<ProjectResponseAdminDto>> {
  const rb = new RequestBuilder(rootUrl, adminProjectsControllerUnpublishProjectV1.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProjectResponseAdminDto>;
    })
  );
}

adminProjectsControllerUnpublishProjectV1.PATH = '/v1/admin/projects/{id}/unpublish';
